/* MMG-REVIEW-DISPLAY-001 v1.3 — canonical Judge.me v3 render adapter. */
(function(){
  'use strict';
  var ROOT_ID='judgeme_product_reviews';
  var GOLD='#FFC518';
  var EMPTY='#E5E7EB';
  var LOGO='https://cdn.shopify.com/s/files/1/0754/4337/2186/files/mindset-media-group-official-logo_56255ffc-98a8-4f34-aa30-ea187620cda7.jpg?v=1786924671';
  var observer=null;
  var scheduled=false;

  function clamp(n,min,max){return Math.max(min,Math.min(max,n));}
  function parseRating(label){
    if(!label)return null;
    var s=String(label);
    var m=s.match(/reviews?\s+with\s+([1-5](?:\.\d+)?)\s+star/i);
    if(m)return clamp(parseFloat(m[1]),0,5);
    m=s.match(/rating(?:\s+is|\s*:)?\s*([0-5](?:\.\d+)?)/i);
    if(m)return clamp(parseFloat(m[1]),0,5);
    m=s.match(/([0-5](?:\.\d+)?)\s*(?:out\s+of\s+5\s*)?stars?/i);
    return m?clamp(parseFloat(m[1]),0,5):null;
  }
  function starSvg(fill,index){
    var id='mmgStarGrad'+Math.random().toString(36).slice(2)+index;
    var pct=Math.round(clamp(fill,0,1)*100);
    return '<svg class="mmg-v3-star" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" style="display:block;flex:0 0 auto">'+
      '<defs><linearGradient id="'+id+'" x1="0%" x2="100%"><stop offset="0%" stop-color="'+GOLD+'"/><stop offset="'+pct+'%" stop-color="'+GOLD+'"/><stop offset="'+pct+'%" stop-color="'+EMPTY+'"/><stop offset="100%" stop-color="'+EMPTY+'"/></linearGradient></defs>'+
      '<path fill="url(#'+id+')" d="M12 2.2l2.97 6.02 6.64.97-4.8 4.68 1.13 6.61L12 17.36l-5.94 3.12 1.13-6.61-4.8-4.68 6.64-.97L12 2.2z"/></svg>';
  }
  function normalizeStars(root){
    root.querySelectorAll('[aria-label*="star" i]').forEach(function(el){
      if(el.dataset.mmgStarsNormalized==='1')return;
      var rating=parseRating(el.getAttribute('aria-label'));
      if(rating===null)return;
      var descendants=el.querySelectorAll('span,svg,i').length;
      if(descendants<5 && el.children.length<5)return;
      var html='';
      for(var i=0;i<5;i++)html+=starSvg(clamp(rating-i,0,1),i);
      el.innerHTML='<span class="mmg-v3-stars" style="display:inline-flex;align-items:center;gap:2px" aria-hidden="true">'+html+'</span>';
      el.dataset.mmgStarsNormalized='1';
      el.style.color=GOLD;
    });
  }
  function reviewContext(el,root){
    var node=el;
    for(var i=0;i<7 && node && node!==root;i++,node=node.parentElement){
      var cls=String(node.className||'');
      var text=(node.textContent||'').trim();
      if(/review|rev-|reviewer|author/i.test(cls) && text.length>20)return node;
      if(/\b\d{2}\/\d{2}\/\d{4}\b/.test(text) && text.length>35)return node;
    }
    return null;
  }
  function normalizeAvatars(root){
    root.querySelectorAll('div,span').forEach(function(el){
      if(el.dataset.mmgLogoAvatar==='1'||el.querySelector('img'))return;
      var initial=(el.textContent||'').trim();
      if(!/^[A-Za-z]$/.test(initial))return;
      var cls=String(el.className||'');
      var explicitAvatar=/avatar|profile|reviewer.*icon|author.*icon/i.test(cls);
      var context=reviewContext(el,root);
      if(!explicitAvatar && !context)return;
      if(!explicitAvatar){
        var r=el.getBoundingClientRect();
        if(r.width<24||r.width>110||r.height<24||r.height>110||Math.abs(r.width-r.height)>14)return;
      }
      el.dataset.mmgLogoAvatar='1';
      el.textContent='';
      el.style.background='transparent';
      el.style.overflow='hidden';
      el.style.borderRadius='50%';
      el.style.display='grid';
      el.style.placeItems='center';
      var img=document.createElement('img');
      img.src=LOGO;
      img.alt='';
      img.setAttribute('aria-hidden','true');
      img.style.width='100%';
      img.style.height='100%';
      img.style.objectFit='cover';
      img.style.display='block';
      el.appendChild(img);
    });
  }
  function apply(){
    scheduled=false;
    var root=document.getElementById(ROOT_ID);
    if(!root)return;
    normalizeStars(root);
    normalizeAvatars(root);
  }
  function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(apply);}
  function start(){
    var root=document.getElementById(ROOT_ID);
    if(!root){setTimeout(start,100);return;}
    apply();
    observer=new MutationObserver(schedule);
    observer.observe(root,{childList:true,subtree:true});
    [100,250,500,1000,2000].forEach(function(ms){setTimeout(apply,ms);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();